import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import Aqp from '../../../libs/mk-react-aqp';

import {fetchReportings} from "../../../creators/reportings";
import Pagination from "../../components/Pagination";
import {PageLoader} from "../../components/Loader";
import createLink from "../../../libs/createLink";
import {Button, ButtonGroup} from "../../components/Button";

import {Link} from "react-router-dom";

import Icon from "../../components/Icon";
import DateSince from "../../components/Date";

let mapping = {
    "sort" : "trie",
    "kind" : "type",
    "owner" : "membre"
};

class ListReportings extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 20,
            page: 1,
            sort: "-createdAt",
            status : 0,
            kind : 0,
            content : null,
            owner : null
        };

        this.statusList = [{_id : 0, title : "Nouveaux"}, {_id : 1, title : "En cours"}, {_id : 2, title : "Résolus"}];
        this.kindList = [
            {_id : 0, title : "Tous"},
            {_id : "album", title : "Album"},
            {_id : "article", title : "Article"},
            {_id : "roomMessage", title : "Chat"},
            {_id : "topicComment", title : "Commentaire Forum"},
            {_id : "topic", title : "Forum"},
            {_id : "media", title : "Média"},
            {_id : "user", title : "Profil"},
            {_id : "status", title : "Statut"}
        ];

        this.currentLink = createLink("pcModerator");

        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page'],
            currentLink: this.currentLink,
            filterDefault: this.filter
        });

        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1}
        };

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleStatus = this.handleStatus.bind(this);
        this.handleKind = this.handleKind.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.fetchReportings(this.state.filter);
    }

    fetchReportings(filter){
        this.props.fetchReportings(this.aqp.set(filter));
    }

    handleStatus(value){
        let filter = {...this.state.filter, page : 1, status : value};
        this.props.history.push(this.currentLink);
        this.setState({filter});
        this.fetchReportings(filter);
        window.scrollTo(0, 0);
    }

    handleKind(value){
        let filter = {...this.state.filter, page : 1, kind : value};
        this.props.history.push(this.currentLink);
        this.setState({filter});
        this.fetchReportings(filter);
        window.scrollTo(0, 0);
    }

    handleSort(value){
        let filter = {...this.state.filter, page : 1, sort : value};
        this.props.history.push(this.currentLink);
        this.setState({filter});
        this.fetchReportings(filter);
        window.scrollTo(0, 0);
    }

    handleFilter(name,value){
        let filter = {...this.state.filter, page : 1, [name] : value};
        this.props.history.push(this.currentLink);
        this.setState({filter});
        this.fetchReportings(filter);
        window.scrollTo(0, 0);
    }

    resetFilter(){
        this.props.history.push(this.currentLink);
        this.setState({filter : this.filter});
        this.fetchReportings(this.filter);
        window.scrollTo(0, 0);
    }

    handleChangePage(page, link) {
        let filter = {...this.state.filter, page};
        if (page === 1) {
            this.props.history.push(link);
        } else {
            this.props.history.push(link + '/' + page);
        }
        this.setState({filter});
        this.fetchReportings(filter);
        window.scrollTo(0, 0);
    }


    render() {
        let totalPage = this.props.reportingsTotal ? Math.ceil(this.props.reportingsTotal / this.state.filter.limit) : 0;


        return !this.props.reportingsInitialized ? (<PageLoader />) : (
            <div id="list-reportings">
                <div className="sub-controls-row">
                    Statut
                    <ButtonGroup className={"w-30 mb-16"}>
                        {this.statusList.map((item, index) => (
                            <Button key={`status_${index}`}
                                    active={this.state.filter.status === item._id ? 'active no-cursor' : ''}
                                    onClick={() => this.state.filter.status !== item._id ? this.handleFilter('status',item._id) : null} content={item.title}/>
                        ))}
                    </ButtonGroup>
                    {this.state.filter.content === null && this.state.filter.owner === null ? (
                        <Fragment>
                            Type de contenu
                            <ButtonGroup>
                                {this.kindList.map((item, index) => (
                                    <Button key={`status_${index}`}
                                            active={this.state.filter.kind === item._id ? 'active no-cursor' : ''}
                                            onClick={() => this.state.filter.kind !== item._id ? this.handleFilter('kind',item._id) : null} content={item.title}/>
                                ))}
                            </ButtonGroup>
                        </Fragment>
                    ) : (
                        <Button onClick={() => this.resetFilter()}
                                btnStyle={"primary-reverse"}
                                className={"right"}
                                size={"small"}
                                content={"Voir tous les rapports"}/>
                    )}

                </div>
                {this.props.reportingsTotal > 0 ? (
                    <div className="table-container">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Membre </th>
                                <th>Type de contenu</th>
                                <th>Dernier commentaire</th>
                                <th>Mise à jour <span onClick={() =>this.handleFilter('sort',"updateAt")}><Icon type={"chevron-up"} /></span> <span onClick={() =>this.handleFilter('sort',"-updateAt")}><Icon type={"chevron-down"} /></span></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.reportings.map(item => (
                                <tr key={item._id}>
                                    <td><a href={createLink("userProfile", item.owner)} target={"new"}>{item.owner?.username}</a></td>
                                    <td>{item.typeName}</td>
                                    <td>{item.lastCommentOwner && (<a href={createLink("userProfile", item.lastCommentOwner)} target={"new"}>{item.lastCommentOwner.username}</a>)}</td>
                                    <td><DateSince date={item.updatedAt} currentFormat={false}/></td>
                                    <td>
                                        {item?.content ? <Link to={`${this.currentLink}/${item._id}`} className="btn btn-outline-primary btn-sm">
                                            Voir
                                        </Link> : (<div className={"text-danger mt-16"}>Contenu Effacer</div>)}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className={"no-content"}>Message de modération</div>
                )}

                <Pagination currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            {...this.aqp.queryUrl(this.state.filter, mapping)}
                            handleChangePage={this.handleChangePage}/>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        reportingsInitialized: state.reportings.initialized,
        reportingsLoading: state.reportings.loading,
        reportings: state.reportings.data,
        reportingsTotal: state.reportings.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchReportings
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ListReportings);
